import service from './index'

export default {
  async getAll (page = 0, search = '') {
    const { data: runners } = await service.get(`runners/analytics?page=${page}&size=50&sort=id,desc&searchValue=${search}`)

    return runners
  },
  async getAllWithRunCompleted (page = 0) {
    const { data: runners } = await service.get(`runners/analytics?page=${page}&size=50&sort=daysSinceLastClass,asc&excludeNoRuns=true`)

    return runners
  },
  async getRunner (runnerId) {
    const { data: runner } = await service.get(`runners/${runnerId}`)

    return runner
  },
  async updateRunner (data) {
    try {
      await service.put(`runners/update`, data)

      return true
    } catch (e) {
      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/runners.js